import { useTranslation } from "react-i18next";

export default function BidsAndCommissions(prop) {
  const data = prop.data;
  const { t } = useTranslation();

  return (
    <>
     <div id="content" class="dashboard-wrap campaign-section">
      <div className="listing-content">
        <div className="project-information">
          <h6>{t("finance.bids_commissions")}</h6>
          <div className="translation-summary">
            <div className="project-table">
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.number_of_submitted_bid")}</div>
                  <div className="text">{data?.numberSubmittedBids}</div>
                </li>
                <li className="finance-columns"></li>
              </ul>
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.high_bid")}</div>
                  <div className="text">{data?.highBidAmount?.displayWithDecimals}</div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.low_bid")}</div>
                  <div className="text">{data?.lowBidAmount?.displayWithDecimals}</div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.subscriber_commission_rate")}</div>
                  <div className="text">{data?.cloudwordsCommission ? data?.cloudwordsCommission+"%" : "N/A"}</div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.service_provider_commission_rate")}</div>
                  <div className="text">0%</div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns">
                  <div className="title">{t("finance.original_subscriber_project_value")}</div>
                  <div className="text">
                    {data?.customerAmount?.displayWithDecimals}
                  </div>
                </li>
                <li className="finance-columns">
                  <div className="title">{t("finance.subscriber_project_value")}</div>
                  <div className="text"> {data?.customerAmount?.displayWithDecimals} </div>
                </li>
              </ul>
              <ul>
                <li className="finance-columns last-row">
                  <div className="title">{t("finance.original_service_provider_project_value")}</div>
                  <div className="text">{data?.vendorAmount?.displayWithDecimals}</div>
                </li>
                <li className="finance-columns last-row">
                  <div className="title">{t("finance.service_provider_project_value")}</div>
                  <div className="text">{data?.vendorAmount?.displayWithDecimals}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}
